import React from "react";
import { PaperPlaneTilt, User, CalendarBlank } from "@phosphor-icons/react";

const OPTIONS = [
  { key: "pro", label: "Invia link al professionista", hint: "Sceglie lui data e ora da una pagina dedicata", Icon: PaperPlaneTilt },
  { key: "client", label: "Invia link al cliente finale", hint: "Il cliente sceglie data e ora da una pagina dedicata", Icon: User },
  { key: "manual", label: "Scegli data manualmente", hint: "Selezioni tu lo slot dal calendario", Icon: CalendarBlank },
];

export const SiteVisitModePicker = ({ value, onChange, clientEmail }) => {
  const noClient = !(clientEmail || "").trim();
  return (
    <div className="grid sm:grid-cols-3 gap-2" data-testid="visit-mode-picker">
      {OPTIONS.map(({ key, label, hint, Icon }) => {
        const disabled = key === "client" && noClient;
        const active = value === key;
        return (
          <button
            key={key}
            type="button"
            disabled={disabled}
            onClick={() => onChange(key)}
            title={disabled ? "Nessuna email cliente inserita" : undefined}
            className={`text-left rounded-lg border p-3 transition-colors ${
              disabled ? "opacity-50 cursor-not-allowed border-slate-200 bg-slate-50"
                : active ? "border-blue-500 bg-blue-50 ring-1 ring-blue-500"
                  : "border-slate-200 bg-white hover:border-blue-400 hover:bg-blue-50/50"
            }`}
            data-testid={`visit-mode-${key}`}
          >
            <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
              <Icon size={16} weight={active ? "fill" : "regular"} className="text-blue-600" />
              {label}
            </div>
            <div className="text-[11px] text-slate-500 mt-1">
              {disabled ? "Nessuna email cliente inserita" : hint}
            </div>
          </button>
        );
      })}
    </div>
  );
};
